import { z } from 'zod';

/**
 * Briques de champ du domaine facturation.
 *
 * **Tout montant est un entier de centimes.** La V1 stockait `subtotal_ht`, `total_ttc` et
 * `amount_paid` en `text` et les additionnait avec `parseFloat` (`docs/audit/audit-schema.md`
 * §2.5) : c'est le défaut comptable central de la V1. Aucun montant décimal ne franchit le
 * contrat réseau, ni en entrée ni en sortie.
 *
 * Les taux sont en **points de base** (1 % = 100 bps) pour la même raison : 17 % s'écrit 1700, un
 * entier exact, là où 0,17 n'est pas représentable en binaire.
 */

/** Plafond de sécurité : dix millions d'euros, largement au-delà d'une facture de cabinet. */
const MAX_CENTS = 1_000_000_000;

/** Montant signé, en centimes entiers. */
export const centsSchema = z.number().int().min(-MAX_CENTS).max(MAX_CENTS);

/** Montant positif ou nul, en centimes entiers. */
export const nonNegativeCentsSchema = z.number().int().min(0).max(MAX_CENTS);

/** Montant strictement positif : un encaissement ou un avoir de zéro n'a pas de sens. */
export const positiveCentsSchema = z.number().int().min(1).max(MAX_CENTS);

/** Taux en points de base, de 0 à 100 % inclus. */
export const basisPointsSchema = z.number().int().min(0).max(10_000);

/** Quantité d'une ligne de facture : `numeric(8,2)`, donc deux décimales et six chiffres devant. */
export const lineQuantitySchema = z
  .number()
  .min(0.01)
  .max(999_999.99)
  .refine((value) => Number.isInteger(Math.round(value * 100)), 'Deux décimales au maximum');

/*
 * La pagination des quatre listes du module — factures, avoirs, relances et ordonnances — est
 * dans `_pagination.ts`, importée directement par les fichiers qui s'en servent : elle n'avait
 * rien de comptable, et la console de plateforme avait besoin exactement de la même.
 */
